export default __webpack_public_path__ + "static/media/industrialwhite.74f3d1ce.png";